<template>
  <form role='form' @submit.prevent='submit'>
    <div class='row' style='margin-bottom: 10px'>
      <div class='col' style='display: flex'>
        <span
          style='color: #008dbd; cursor: pointer; margin-left: auto; margin-right: 15px'
          @click='toggleOptionals()'
        >
          <span v-if='showOptionals' class='fa fa-minus-circle' />
          <span v-else class='fa fa-plus-circle' />

          {{ $t('optional_fields') }}
        </span>
      </div>
    </div>
    <div class='row'>
      <div class='col-lg-6'>
        <div class='form-group'>

          <select
            :value='value.countryCode'
            @change="e => onInput(e, 'countryCode')"
            class='form-control'
          >
            <option value=''>{{ $t('all_countries') }}</option>
            <option v-for="(value, key) in countries" :key='key' :value='key'>{{ $t('countries.' + key) }}</option>
          </select>
        </div>

        <template v-if='showOptionals'>
          <div class='form-group'>
            <input
              :value='value.streetAddress'
              @input="e => onInput(e, 'streetAddress')"
              :placeholder="$t('placeholder_street')"
              type='text'
              class='form-control'
            >
          </div>
          <div class='form-group'>
            <input
              :value='value.postalCode'
              @input="e => onInput(e, 'postalCode')"
              :placeholder="$t('placeholder_zip')"
              type='text'
              class='form-control'
            >
          </div>
          <div class='form-group'>
            <input
              :value='value.addressLocality'
              @input="e => onInput(e, 'addressLocality')"
              :placeholder="$t('placeholder_city')"
              type='text'
              class='form-control'
            >
          </div>
        </template>
      </div>
      <div class='col-lg-6'>
        <div class='form-group'>
          <div class='input-group'>
            <input
              :value='value.licenseeName'
              @input="e => onInput(e, 'licenseeName')"
              :placeholder="$t('placeholder_company')"
              type='text'
              class='form-control'
            >
            <span class='input-group-btn'>
              <button :disabled='value.licenseeName.length < 3' class='btn btn-primary'
                      type='submit'>{{ $t('search_button') }}</button>
            </span>
          </div>
        </div>

        <span style='cursor: pointer'>
          {{ $t('example_search') }}:
          <span @click='submitExample' style='color: #008dbd'>{{ $t('example_company_name') }}</span>
        </span>
      </div>
    </div>
  </form>
</template>

<script>

import countries from '../i18n/de/countries'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        licenseeName: '',
        countryCode: '',
        streetAddress: '',
        addressLocality: '',
        postalCode: ''
      })
    }
  },
  data: () => ({
    optionals: false,
    countries: countries
  }),
  computed: {
    showOptionals() {
      return this.optionals || this.value.streetAddress || this.value.addressLocality || this.value.postalCode
    }
  },
  watch: {
    showOptionals: {
      handler() {
        if (!this.optionals && (this.value.streetAddress || this.value.addressLocality || this.value.postalCode)) {
          this.optionals = true
        }
      },
      deep: true
    }
  },
  methods: {
    onInput(e, key) {
      this.value[key] = e.target.value
      this.$emit('input', this.value)
    },
    toggleOptionals() {
      if (this.optionals) {
        this.value.streetAddress = ''
        this.value.addressLocality = ''
        this.value.postalCode = ''
      }

      this.optionals = !this.optionals
    },
    submit() {
      this.$emit('submit', this.value)
    },
    submitExample() {
      this.optionals = true
      this.value.countryCode = ''
      this.value.licenseeName = 'GS1 Germany GmbH'
      this.value.streetAddress = ''
      this.value.addressLocality = 'Köln'
      this.value.postalCode = ''
      this.submit()
    }
  },
  i18n: {
    messages: {
      de: {
        all_countries: 'Alle Länder',
        search_button: 'Suchen',
        placeholder_street: 'Strasse (optional)',
        placeholder_city: 'Stadt (optional)',
        placeholder_zip: 'Postleitzahl (optional)',
        placeholder_company: 'Firmenname',
        example_search: 'Beispielsuche',
        example_company_name: 'Firmenname',
        optional_fields: 'Optionale Felder'
      },
      en: {
        all_countries: 'All countries',
        search_button: 'Search',
        placeholder_street: 'Street (optional)',
        placeholder_city: 'City (optional)',
        placeholder_zip: 'Zip (optional)',
        placeholder_company: 'Company name',
        example_search: 'Example search',
        example_company_name: 'Company name',
        optional_fields: 'optional fields'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CompanySearchForm.vue